import type { SVGProps } from "react";

/**
 * arrow-right
 * @category Arrows
 */
export default function IconArrowRight(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        d='M14 5.75L20.25 12L14 18.25M19.5 12H3.75'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
